import { rootApi } from "../../api/rootApi";

/**
 * Read-only tracking APIs for scheme membership.
 * All writes go through membershipApi / membershipDetailsApi; these only read
 * the state row and the append-only audit ledger.
 */
export const schemeMembershipApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchSchemeMembershipSummary: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/scheme-membership/summary/${params.scheme_id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),

    fetchSchemeMembershipUserLedger: builder.mutation({
      query: (params) => {
        const query = new URLSearchParams({
          limit: String(params.limit ?? 100),
          offset: String(params.offset ?? 0),
          ...(params.scheme_id ? { scheme_id: String(params.scheme_id) } : {}),
        }).toString();
        return {
          method: "GET",
          url: `/tenant/scheme-membership/user/${params.app_user_id}?${query}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
  }),
});

export const {
  useFetchSchemeMembershipSummaryMutation,
  useFetchSchemeMembershipUserLedgerMutation,
} = schemeMembershipApi;
